<template>
  <v-row>
    <v-col cols="12">
      <h2>Agentes</h2>
    </v-col>

    <v-col cols="12" class="mb-10">

      <v-data-table
        :headers="agentesTable"
        :items="report"
        item-key="name"
        class="elevation-1"
        :loading="loading"
        :options.sync="tableOptions"
        :server-items-length="totalItems"
        :footer-props="footerProps"
        loading-text="Cargando..."
      >
        <template v-slot:top>
          <v-text-field v-model="search" label="Buscar" class="mx-4"></v-text-field>
        </template>
        <template v-slot:item.sexo="{ item }">
          <div v-if="item.sexo == 1"> Masculino </div>
          <div v-if="item.sexo == 2">Femenino</div>
        </template>
        <template v-slot:item.status="{ item }">
          <div v-if="item.status == -1">
            <v-chip color="red" dark>Inactivo</v-chip>
          </div>
          <div v-if="item.status == 1">
            <v-chip color="green" dark>Activo</v-chip>
          </div>
        </template>
        <template v-slot:item.uuid="{ item }">
          <v-icon small class="mr-2" @click="cotizaItem(item.uuid)">
            mdi-file-find
          </v-icon>
        </template>

      </v-data-table>

    </v-col>
  </v-row>
</template>

<script>

export default {
  data() {
    return {
      agentes: [],
      loading: true,
      search: "",
      totalItems: 0,
      searchDebounce: null,
      tableOptions: {
        page: 1,
        itemsPerPage: 10,
      },
      footerProps: {
        "items-per-page-options": [10, 25, 50],
      },
      agentesTable: [

        { text: "Nombre", align: "start", sortable: false, value: "nombreCompleto", },
        { text: "Correo Electronico", value: "correo" },
        { text: "Celular", value: "celular" },
        { text: "Teléfono", value: "telefono" },
        { text: "Fecha de Nacimiento", value: "fechaNacimiento" },
        { text: "Sexo", value: "sexo" },
        { text: "Activo", value: "status" },
        { text: "RFC", value: "rfc" },
        { text: "Curp", value: "curp" },
        { text: "Cotiza como agente", value: "uuid" },
      ],
      report: [],
    };
  },

  created() {
    this.getAgent();
  },

  computed: {},

  watch: {
    search() {
      clearTimeout(this.searchDebounce);
      this.searchDebounce = setTimeout(() => {
        this.tableOptions.page = 1;
        this.getAgent();
      }, 300);
    },
    tableOptions: {
      deep: true,
      handler() {
        this.getAgent();
      },
    },
  },

  methods: {
    getAgent() {
      this.loading = true;
      const config = {
        headers: {
          Authorization: "Bearer " + localStorage.agenteAccessToken,
        },
      };
      const payload = {
        pagina: this.tableOptions.page,
        elementosPagina: this.tableOptions.itemsPerPage,
        paginado: true,
      };

      if (this.search) {
        payload.busquedaString = this.search;
      }

      this.$axios
        .post("/v1/agente/filter/list", payload, config)
        .then((response) => {
          const data = response.data?.data || {};
          const agentes = data.agentes || [];
          this.totalItems = data.total || 0;
          this.agentes = agentes;
          this.report = agentes;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    cotizaItem(item) {
      this.$router.push(`/cotiza/segurify/${item}`)
    },

  },
};
</script>
<style scoped>
</style>
